import React, { useContext, useEffect, useState } from 'react'
import { Flex, Box } from 'reflexbox'
import { ThemeContext } from 'styled-components'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'

import { useUser } from 'context/user-context'
import * as partnersService from 'services/partners'

import Modal from 'components/Modal/Modal'
import Loader from 'components/Loader'
import Card from 'components/Card'
import Button from 'components/Button'
import { Title, SemiTitle, Text, Paragraph } from 'components/Typography'
import { Close as CloseIcon } from 'components/Icons'

import { APIKeyButton, APIKeyText, ModalCloseButton } from './styles'

const Configurations = () => {
  const theme = useContext(ThemeContext)
  const {
    user: { user, phones, company_name, document, responsible_name },
  } = useUser()
  const [apiKeyPrefix, setAPIKeyPrefix] = useState(null)
  const [isLoading, setLoading] = useState(true)
  const [isNewAPIKeyModalOpen, setNewAPIKeyModalOpen] = useState(false)
  const [isRenewAPIKeyModalOpen, setRenewAPIKeyModalOpen] = useState(false)
  const [isGeneratingNewAPIKey, setGeneratingNewAPIKey] = useState(false)
  const [newAPIKey, setNewAPIKey] = useState(null)

  const fetchPartnerAPIKeys = async () => {
    try {
      const prepaidKey = await partnersService.getAPIKey()
      setAPIKeyPrefix(prepaidKey.prefix)

      setLoading(false)
    } catch (e) {
      console.log(e)
      toast.error('Não foi possível carregar as informações da API Key.')
    }
  }

  const handleNewAPIKeyGeneration = async () => {
    setRenewAPIKeyModalOpen(false)
    setNewAPIKeyModalOpen(true)
    setGeneratingNewAPIKey(true)

    try {
      const { key } = await partnersService.createNewAPIKey()

      setNewAPIKey(key)
    } catch (e) {
      console.log(e)
      toast.error('Não foi possível gerar a nova API Key')
    } finally {
      setGeneratingNewAPIKey(false)
    }

    fetchPartnerAPIKeys(true)
  }

  useEffect(() => {
    fetchPartnerAPIKeys(true)
  }, [user])

  return (
    <>
      <Flex flexDirection='column' width={1}>
        <Title as='h3'>Configurações</Title>
        <Card mt={24}>
          {isLoading ? (
            <Flex justifyContent='center'>
              <Loader />
            </Flex>
          ) : (
            <Flex flexDirection='column' width={1}>
              <Flex flexDirection='row' flexWrap='wrap'>
                <Flex flexDirection='column' width={['100%', '50%', '50%']}>
                  <Box mb={24}>
                    <SemiTitle color={theme.colors.grays.N500}>CNPJ</SemiTitle>
                    <Text>{document.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5')}</Text>
                  </Box>

                  <Box mb={24}>
                    <SemiTitle color={theme.colors.grays.N500}>Razão social</SemiTitle>
                    <Text>{company_name}</Text>
                  </Box>

                  <Box mb={24}>
                    <SemiTitle color={theme.colors.grays.N500}>Nome do responsável</SemiTitle>
                    <Text>{responsible_name}</Text>
                  </Box>

                  <Box mb={24}>
                    <SemiTitle color={theme.colors.grays.N500}>Telefone</SemiTitle>
                    <Flex>
                      {phones.map(({ number, id }) => (
                        <Text key={id}>{number}</Text>
                      ))}
                    </Flex>
                  </Box>

                  <Box mb={24}>
                    <SemiTitle color={theme.colors.grays.N500}>Email</SemiTitle>
                    <Text>{user.email}</Text>
                  </Box>

                  <Box mb={24}>
                    <SemiTitle color={theme.colors.grays.N500}>API-KEY - Pré-Pago</SemiTitle>
                    {apiKeyPrefix ? (
                      <>
                        <Text>{apiKeyPrefix}******************</Text>
                        <APIKeyButton onClick={() => setRenewAPIKeyModalOpen(true)}>Renovar API-KEY</APIKeyButton>
                      </>
                    ) : (
                      <APIKeyButton onClick={handleNewAPIKeyGeneration}>Gerar API-KEY</APIKeyButton>
                    )}
                  </Box>
                </Flex>
              </Flex>

              <Flex>
                <Button size='big' as={Link} to='/settings/password' outlined mr={24}>
                  Alterar Senha
                </Button>
                <Button size='big' as={Link} to='/settings/edit'>
                  Editar
                </Button>
              </Flex>
            </Flex>
          )}
        </Card>
      </Flex>

      <Modal isOpened={isNewAPIKeyModalOpen}>
        <Card bg='#fff' width={520}>
          <Flex flexDirection='column'>
            <Flex alignItems='center' justifyContent='space-between' mb={20}>
              <SemiTitle>Gerar API-KEY</SemiTitle>

              <ModalCloseButton onClick={() => setNewAPIKeyModalOpen(false)}>
                <CloseIcon />
              </ModalCloseButton>
            </Flex>

            <Paragraph>Nova Api Key gerada e será mostrada somente agora</Paragraph>

            {isGeneratingNewAPIKey ? <Loader /> : <APIKeyText>{newAPIKey}</APIKeyText>}

            <Paragraph>
              Salve sua chave em um lugar seguro, essa é a única vez que poderá visualizá-la. Caso perca o acesso, gere
              uma nova chave.
            </Paragraph>

            <Flex justifyContent='flex-end' mt='30px'>
              <Button variant='tertiary' onClick={() => setNewAPIKeyModalOpen(false)}>
                Fechar
              </Button>
            </Flex>
          </Flex>
        </Card>
      </Modal>

      <Modal isOpened={isRenewAPIKeyModalOpen}>
        <Card bg='#fff' width={520}>
          <Flex flexDirection='column'>
            <Flex alignItems='center' justifyContent='space-between' mb={20}>
              <SemiTitle>Renovar API-KEY</SemiTitle>

              <ModalCloseButton onClick={() => setRenewAPIKeyModalOpen(false)}>
                <CloseIcon />
              </ModalCloseButton>
            </Flex>

            <Paragraph>
              Você tem certeza que deseja invalidar sua API-KEY? Ao invalidar sua chave uma nova será gerada e não será
              mais possível realizar requisições utilizando a antiga.
            </Paragraph>

            <Flex justifyContent='flex-end' mt='30px'>
              <Button variant='tertiary' mr='24px' outlined onClick={() => setRenewAPIKeyModalOpen(false)}>
                Fechar
              </Button>
              <Button variant='tertiary' onClick={() => handleNewAPIKeyGeneration()}>
                Renovar
              </Button>
            </Flex>
          </Flex>
        </Card>
      </Modal>
    </>
  )
}

export default Configurations
